import React, { useState } from 'react';
import TalkCard from '../components/TalkCard';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import { API_BASE_URL } from '../scripts/control';
import ImageCrop from "../components/ImageCrop";
import RichTextInput from '../components/RichTextInput';
import { dataURLtoBlob } from '../../../utils/dataURLtoBlob';

const Talks = () => {
    const { isAdmin, logout } = useAdminAuth();
    const [showModal, setShowModal] = useState(false);
    const [showConfirmCloseModal, setShowConfirmCloseModal] = useState(false);
    const [showCropModal, setShowCropModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);   // imagen original (DataURL)
    const [croppedImage, setCroppedImage] = useState(null); 
    const [bodyContent, setBodyContent] = useState('');
    const [locationContent, setLocationContent] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);

    const handleCreateNew = () => {
        setShowModal(true);
    };

    const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result); // guardamos la imagen en el estado
        setShowCropModal(true);         // modal de crop
      };
      reader.readAsDataURL(file);
    };

    const handleSaveModal = async () => {
        const formData = new FormData();
        const title = document.getElementById('title').value;
        const body = bodyContent;
        const imgFile = document.getElementById('img_url').files[0];
        const imgAlt = document.getElementById('img_alt').value;
        const day = document.getElementById('day').value;
        const hour = document.getElementById('hour').value;
        const location = locationContent;

        formData.append('title', title);
        formData.append('body', body);
        formData.append('day', day);
        formData.append('hour', hour);
        formData.append('location', location);
        formData.append('img_alt', imgAlt);
        const inputFile = document.getElementById('img_url');
        const file = inputFile.files[0];
        if (croppedImage) {
            const { blob, ext, isValid } = dataURLtoBlob(croppedImage);
            const filename = file?.name || `img_${Date.now()}.${ext}`;
            if (isValid && blob.size > 0) {
                formData.append('img_url', blob, filename);
            } else if (file) {
                console.warn('Conversión de imagen recortada falló, usando archivo original');
                formData.append('img_url', file);
            }
        } else if (file) {
            formData.append('img_url', file);
        }

        try {
            const response = await fetch(`${API_BASE_URL}/api/talk_func.php`, {
                method: 'POST',
                body: formData,
                credentials: 'include',
            });

            if (response.status === 401) {
                alert('La sesión ha expirado. Por favor, inicia sesión de nuevo.');
                logout();
                return;
            }

            const result = await response.json();
            if (result.success) {
                alert('Congreso/Seminario guardado con éxito');
                const t = document.getElementById('title');
                if (t) t.value = '';
                const alt = document.getElementById('img_alt');
                if (alt) alt.value = '';
                const d = document.getElementById('day');
                if (d) d.value = '';
                const h = document.getElementById('hour');
                if (h) h.value = '';
                setLocationContent('');
                const f = document.getElementById('img_url');
                if (f) f.value = '';
                setSelectedImage(null);
                setCroppedImage(null);
                setBodyContent('');
                setShowModal(false);
                setRefreshKey((k) => k + 1);
            } else {
                alert('Error al guardar el congreso/seminario: ' + result.message);
            }
        } catch (error) {
            alert('Error al guardar el congreso/seminario: ' + (error.message || 'Error desconocido'));
        } finally {
            setShowModal(false);
        }
    };

    const handleCloseModal = () => {
        setShowConfirmCloseModal(true);
    };

    const handleConfirmClose = () => { // Seguridad para no perder datos
        setShowModal(false);
        setShowConfirmCloseModal(false);
    };

    const handleCancelClose = () => {
        setShowConfirmCloseModal(false);
        setSelectedImage(null);
        setCroppedImage(null);
    };

    const handleCropSave = (cropped) => {
      // 'cropped' es la imagen recortada en DataURL
      setCroppedImage(cropped);
      setShowCropModal(false);
    };

    return (
        <div>
            <h2 className="title">Congresos y Seminarios</h2>
            <hr className="small-hr"></hr><br />
            {isAdmin && (
                <>
                    <button
                        onClick={handleCreateNew}
                        style={{
                            marginBottom: '20px',
                            marginLeft: '25%',
                            padding: '10px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                        }}>
                        Crear nuevo congreso/seminario
                    </button>

                    {showModal && (
                        <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Crear nuevo congreso/seminario</h5>
                                        <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowModal(false)}></button>
                                    </div>
                                    <div className="modal-body">
                                        <form>
                                            <label htmlFor="title">Título del congreso/seminario:</label><br />
                                            <input type="text" id="title" name="title" /><br />
                                            <span id="body-label-talks">Texto principal:</span><br />
                                            <RichTextInput
                                              id="body-talks"
                                              ariaLabelledBy="body-label-talks"
                                              initialContent=""
                                              onChange={(content) => setBodyContent(content)}
                                              placeholder="Pega o escribe aquí el contenido con formato..."
                                              style={{ minHeight: '150px' }}
                                            />
                                            <label htmlFor="img_url">Imagen del congreso/seminario:</label><br />
                                            <input
                                              type="file"
                                              id="img_url"
                                              name="img_url"
                                              accept="image/*"
                                              onChange={handleImageUpload}
                                            />
                                            {/* Previsualización de la imagen */}
                                            {croppedImage ? (
                                              <div>
                                                <p>Previsualización (Imagen recortada):</p>
                                                <img
                                                  src={croppedImage}
                                                  alt="Imagen recortada"
                                                  style={{ maxWidth: '100%' }}
                                                />
                                              </div>
                                            ) : selectedImage ? (
                                              <div>
                                                <p>Previsualización (Sin recortar):</p>
                                                <img
                                                  src={selectedImage}
                                                  alt="Imagen seleccionada"
                                                  style={{ maxWidth: '100%' }}
                                                />
                                              </div>
                                            ) : null}
                                            <label htmlFor="img_alt">Texto alternativo de la imagen:</label>
                                            <small> Necesario para personas con discapacidad visual.</small><br />
                                            <input type="text" id="img_alt" name="img_alt" /><br />
                                            <hr />
                                            <label htmlFor="day">Día del evento:</label><br />
                                            <input type="date" id="day" name="day" /><br />
                                            <label htmlFor="hour">Hora de inicio del evento:</label><br />
                                            <input type="time" id="hour" name="hour" /><br /><br />
                                            <label htmlFor="location">Lugar del evento:</label><br />
                                            <RichTextInput id="location" initialContent={locationContent} onChange={setLocationContent} placeholder="Lugar..." editorKey="talks-location" style={{ minHeight: '60px' }} /><br />
                                        </form>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                                        <button type="button" className="btn btn-primary" onClick={handleSaveModal}>Guardar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
            <TalkCard key={refreshKey} isAdmin={isAdmin} />

            {showConfirmCloseModal && (
                <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmar cierre</h5>
                                <button type="button" className="btn-close" aria-label="Close" onClick={handleCancelClose}></button>
                            </div>
                            <div className="modal-body">
                                <p>¿Quieres abandonar la creación? Se perderán los cambios no guardados.</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCancelClose}>Volver</button>
                                <button type="button" className="btn btn-primary" onClick={handleConfirmClose}>Salir</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Modal de Crop: se abrirá cuando subamos una imagen */}
            {showCropModal && (
              <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog" style={{ maxWidth: '80%' }}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Recortar imagen</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowCropModal(false)}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <ImageCrop image={selectedImage} onImageSave={handleCropSave} />
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
    );
};

export default Talks;
